import createIcon from '../../createIcon';

/**
 * @component @name Hexagon
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMTk5NiAzSDYuNzk5NjFMMS41OTk2MSAxMkw2Ljc5OTYxIDIxSDE3LjE5OTZMMjIuMzk5NiAxMkwxNy4xOTk2IDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hexagon = createIcon('Hexagon', [
  [
    'path',
    { d: 'M17.1996 3H6.79961L1.59961 12L6.79961 21H17.1996L22.3996 12L17.1996 3Z', key: '10hcf2' },
  ],
]);

export default Hexagon;
